import React from "react";
import NavItem from "./NavItem";

/**
 * Navigation Module Component
 * Renders a group of navigation items with a title
 * Adapts to collapsed/expanded sidebar state
 */
const NavModule = ({ module, hoveredItem, setHoveredItem, isCollapsed }) => {
  return (
    <div className="mb-6">
      {/* Module Title - Only show when expanded */}
      {!isCollapsed && (
        <div className="px-4 mb-2">
          <p className="text-white/50 text-[10px] uppercase font-semibold tracking-wider">
            {module.title}
          </p>
        </div>
      )}

      {/* Divider for collapsed state */}
      {isCollapsed && (
        <div className="px-3 mb-2">
          <div className="h-px bg-white/20"></div>
        </div>
      )}

      {/* Module Items */}
      <ul className="space-y-1 px-3">
        {module.items.map((item, index) => (
          <NavItem
            key={index}
            item={item}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
            isCollapsed={isCollapsed}
          />
        ))}
      </ul>
    </div>
  );
};

export default NavModule;
